<template>
  <div>
    <a-table
      :columns="columns"
      :dataSource="data"
      :scroll="{ y: 'calc(100vh - 380px)' }"
      :locale="{
        emptyText: $tc('lang.No_data'),
      }"
      :pagination="{
        total: total,
        current: page,
        pageSize: size,
        onChange: onChangePage,
      }"
    >
    </a-table>
  </div>
</template>
<script>
// const columns = ;

export default {
  data() {
    return {
      data: [],
      page: 1,
      size: 10,
      total: 10,
      loading: true,
      user: {},
      Chinese: '',
    };
  },
  created() {
    this.queryMealUse();
    //判断当前语言环境
    if (this.$i18n.locale === 'zh-CN') {
      this.Chinese = true;
    } else if (this.$i18n.locale === 'en-US') {
      this.Chinese = false;
    }
  },
  computed: {
    language() {
      return this.$i18n.locale;
    },
    columns() {
      return [
        {
          title: this.$tc('lang.UserCenter.Item_Nr'),
          width: 80,
          align: 'center',
          customRender: (text, record, index) => `${index + 1}`,
        },
        {
          title: this.$tc('lang.UserCenter.Package_Order_Nr'),
          dataIndex: 'orderId',
          key: 'orderId',
          width: 160,
          align: 'center',
        },
        {
          title: this.$tc('lang.UserCenter.Package'),
          dataIndex: this.Chinese == true ? 'setmealName' : 'setmealEnname',
          key: this.Chinese == true ? 'setmealName' : 'setmealEnname',
          width: 160,
          align: 'center',
        },
        {
          title: this.$tc('lang.UserCenter.Service_Date'),
          key: 'setmealUsedate',
          dataIndex: 'setmealUsedate',
          width: 160,
          align: 'center',
        },
        {
          title: this.$tc('lang.UserCenter.Total_MD'),
          key: 'setmealUsecount',
          dataIndex: 'setmealUsecount',
          width: 100,
          align: 'center',
        },
        {
          title: this.$tc('lang.UserCenter.Service_Order_Nr'),
          key: 'setmealUseorder',
          dataIndex: 'setmealUseorder',
          width: 200,
          align: 'center',
        },
      ];
    },
  },
  watch: {
    language() {
      if (this.language === 'zh-CN') {
        this.Chinese = true;
      } else if (this.language === 'en-US') {
        this.Chinese = false;
      }
    },
  },
  methods: {
    action(value) {
      console.log(value);
    },
    // 切换页码
    onChangePage(page) {
      this.page = page;
      this.queryMealUse();
    },
    // 表格请求
    queryMealUse() {
      // 获取用户session信息
      this.user = JSON.parse(sessionStorage.getItem('user')) || {};
      this.$http
        .post('/hzwmj/person-setmealuse/getMealUse', {
          // params: {
          personId: this.user.id,
          page: this.page,
          size: this.size,
          // },
        })
        .then(data => {
          if (data.code === 200) {
            const buyData = data.data;
            this.data = buyData.records;
            this.total = buyData.total;
          } else if (data.code === 900) {
            this.$message.error(data.msg);
          } else {
            this.$message.error('系统异常');
          }
        })
        .catch(() => {
          this.data = [];
          this.total = 0;
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="less"></style>
